import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap'
import { useState, useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import API from '../api/api'
import Actions from '../redux/actions'
import io from 'socket.io-client';

export default function TempAccessForm(props) {

    const [selectedAccount, setSelectedAccount] = useState()
    const [selectedProgram, setSelectedProgram] = useState()
    const [duration, setDuration] = useState()
    const [iAgree, setIAgree] = useState(false)
    const [loading, setLoading] = useState(false)
    const [socket, setSocket] = useState(null)

    const curUser = useSelector(state => state.user)
    const accounts = useSelector(state => state.accounts)
    const filenames = useSelector(state => state.filenames)
    const dispatch = useDispatch()


    useEffect(() => {
        const newSocket = io(process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://api.scamwall.io', {
            query: {
                token: localStorage.getItem('refreshToken')
            }
        })
        setSocket(newSocket);
        return () => newSocket.close();
    }, [])


    const newTempAccess = async (e) => {
        e.preventDefault()
        setLoading(true)
        const access = {
            filenameId: selectedProgram,
            userId: selectedAccount,
            duration
        }
        const user = await API.grantAccess(access)

        socket.emit('temp-access', access)
        dispatch(Actions.setToast(`${user.fName} ${user.lName} Granted Temporary Access ✅`, `They received a notification and email with more information.`))

        //socket.emit('temp-access', access)
        dispatch(Actions.updateAccount(user))
   
        setLoading(false)
        props.close()

    }

    return (
        <Container>
            <Form className='mt-4' onSubmit={newTempAccess}>
                <Form.Group className="mb-3 text-start">
                    <Form.Label className='text-start'>User</Form.Label>
                    <Form.Select aria-label="User Selection" required value={selectedAccount} onChange={e => setSelectedAccount(e.target.value)}>
                        <option value='' >Select User</option>
                        <option value={curUser?._id}>{curUser?.fName} {curUser?.lName} (you)</option>
                        {accounts?.map(user => <option key={user._id} value={user._id}>{user.fName} {user.lName}</option>)}

                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3 text-start">
                    <Form.Label className='text-start'>Program</Form.Label>
                    <Form.Select aria-label="Program Selection" required value={selectedProgram} onChange={e => setSelectedProgram(e.target.value)}>
                        <option value='' >Select Program</option>
                        {filenames?.map(filename => <option key={filename._id} value={filename._id}>{filename.displayName}</option>)}

                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3 text-start">
                    <Form.Label className='text-start' >Duration</Form.Label>
                    <Form.Select aria-label="Duration Selection" required value={duration} onChange={e => setDuration(e.target.value)}>
                        <option value=''  >Select Duration</option>
                        <option value={5}>5 Minutes</option>
                        <option value={15}>15 Minutes</option>
                        <option value={30}>30 Minutes</option>
                        <option value={60}>1 Hour</option>
                        <option value={180}>3 Hours</option>
                        <option value={360}>6 Hours</option>

                    </Form.Select>
                </Form.Group>

                <Form.Check
                    type={'checkbox'}
                    value={iAgree}
                    onChange={() => setIAgree(!iAgree)}
                    label={`I understand that by granting temporary access, the selected user's computer will be vulnerable.`}
                />

                {loading && <div className='text-center my-2'><Spinner animation='border'></Spinner></div>}
                <div className='text-center mt-4'>
                    <Button type='submit' disabled={!iAgree || loading}>Submit</Button>

                </div>

            </Form>
        </Container>
    )
}